// @core/api/endpoints/tenant/get_tenant_onboarding.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantOnboardingResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant onboarding progress
 * Returns the current onboarding progress for a tenant, including completed and pending steps. Available to tenant admins and the owner.
 */
export async function GetTenantOnboarding(
  tenant_id: string,
  options?: RequestOptions
): Promise<TenantOnboardingResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/onboarding`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<TenantOnboardingResponse>(requestPath, { ...requestOptions });
}
